
export default function () {
    return {
        "Supprimer": {
            "fr": "Supprimer",
            "en": "Delete"
        },
        "Commander": {
            "fr": "Commander",
            "en": "Checkout"
        },
        "Panier d’achat": {
            "fr": "Panier d’achat",
            "en": "Cart"
        },
        "Merci de votre commande": {
            "fr": "Merci de votre commande",
            "en": "Thank you for your order"
        },
        "Numéro de facture": {
            "fr": "Numéro de facture",
            "en": "Invoice number"
        },
        "Informations client": {
            "fr": "Informations client",
            "en": "Customer information"
        },
        "Facturé à": {
            "fr": "Facturé à",
            "en": "Billed to"
        },
        "Informations de facturation": {
            "fr": "Informations de facturation",
            "en": "Billing information"
        },
        "Informations de livraison": {
            "fr": "Informations de livraison",
            "en": "Shipping information"
        },
        "Détails de la commande": {
            "fr": "Détails de la commande",
            "en": "Order details"
        },
        "Produit": {
            "fr": "Produit",
            "en": "Product"
        },
        "Prix": {
            "fr": "Prix",
            "en": "Price"
        },
        "Quantité": {
            "fr": "Quantité",
            "en": "Quantity"
        },
        "Total": {
            "fr": "Total",
            "en": "Total"
        },
        "Sous-total": {
            "fr": "Sous-total",
            "en": "Subtotal"
        },
        "Taxes": {
            "fr": "Taxes",
            "en": "Taxes"
        },
        "Livraison": {
            "fr": "Livraison",
            "en": "Shipping"
        },
        "Rabais": {
            "fr": "Rabais",
            "en": "Discount"
        },
        "Note": {
            "fr": "Note",
            "en": "Order note"
        },
        "Facturation": {
            "fr": "Facturation",
            "en": "Billing"
        },
        "Prénom": {
            "fr": "Prénom",
            "en": "First name"
        },
        "Nom": {
            "fr": "Nom",
            "en": "Last name"
        },
        "Téléphone": {
            "fr": "Téléphone",
            "en": "Phone"
        },
        "Code de pays": {
            "fr": "Code de pays",
            "en": "Country code"
        },
        "Choisissez un pays": {
            "fr": "Choisissez un pays",
            "en": "Choose a country"
        },
        "Numéro de téléphone": {
            "fr": "Numéro de téléphone",
            "en": "Phone number"
        },
        "Exemple:": {
            "fr": "Exemple:",
            "en": "Example:"
        },
        "Courriel": {
            "fr": "Courriel",
            "en": "Email"
        },
        "Adresse postale": {
            "fr": "Adresse postale",
            "en": "Postal address"
        },
        "Complément d'adresse": {
            "fr": "Complément d'adresse",
            "en": "Address line 2"
        },
        "Ville": {
            "fr": "Ville",
            "en": "City"
        },
        "Pays": {
            "fr": "Pays",
            "en": "Country"
        },
        "Canada": {
            "fr": "Canada",
            "en": "Canada"
        },
        "États-Unis": {
            "fr": "États-Unis",
            "en": "United States"
        },
        "Province": {
            "fr": "Province",
            "en": "State"
        },
        "Mon adresse de facturation est différente de mon adresse de livraison": {
            "fr": "Mon adresse de facturation est différente de mon adresse de livraison",
            "en": "My billing address is different from my shipping address"
        },
        "Code postal": {
            "fr": "Code postal",
            "en": "Postal code"
        },
        "Ajouter une remise": {
            "fr": "Ajouter une remise",
            "en": "Add discount"
        },
        "Code de remise": {
            "fr": "Code de remise",
            "en": "Discount code"
        },
        "Ajouter": {
            "fr": "Ajouter",
            "en": "Add"
        },
        "Annuler": {
            "fr": "Annuler",
            "en": "Cancel"
        },
        "Votre commande": {
            "fr": "Votre commande",
            "en": "Your order"
        },
        "Remises": {
            "fr": "Remises",
            "en": "Discounts"
        },
        "Entrer votre adresse pour calculer les taxes": {
            "fr": "Entrer votre adresse pour calculer les taxes",
            "en": "Enter your address to calculate taxes"
        },
        "Votre panier est vide": {
            "fr": "Votre panier est vide",
            "en": "Your cart is empty"
        },
        "Passer au paiement": {
            "fr": "Passer au paiement",
            "en": "Proceed to payment"
        },
        "Modifier mon panier": {
            "fr": "Modifier mon panier",
            "en": "Edit my cart"
        },
        "Aucune adresse trouvée": {
            "fr": "Aucune adresse trouvée",
            "en": "No address found"
        },
        "Connexion": {
            "fr": "Connexion",
            "en": "Login"
        },
        "Mot de passe": {
            "fr": "Mot de passe",
            "en": "Password"
        },
        "Mot de passe oublié ?": {
            "fr": "Mot de passe oublié ?",
            "en": "Forgot password ?"
        },
        "Soumettre le formulaire de connexion": {
            "fr": "Soumettre le formulaire de connexion",
            "en": "Submit login form"
        },
        "Vous n’avez pas de compte ?": {
            "fr": "Vous n’avez pas de compte ?",
            "en": "Don't have an account ?"
        },
        "Menu": {
            "fr": "Menu",
            "en": "Menu"
        },
        "Historique": {
            "fr": "Historique",
            "en": "History"
        },
        "Se déconnecter": {
            "fr": "Se déconnecter",
            "en": "Logout"
        },
        "Configuration": {
            "fr": "Configuration",
            "en": "Settings"
        },
        "Bonjour": {
            "fr": "Bonjour",
            "en": "Hello"
        },
        "Historique d'achat": {
            "fr": "Historique d'achat",
            "en": "Purchase history"
        },
        "Aucune commande.": {
            "fr": "Aucune commande.",
            "en": "No order."
        },
        "Commande #": {
            "fr": "Commande #",
            "en": "Order #"
        },
        "Charger plus": {
            "fr": "Charger plus",
            "en": "Load more"
        },
        "Configuration du compte": {
            "fr": "Configuration du compte",
            "en": "Account settings"
        },
        "Titulaire du compte": {
            "fr": "Titulaire du compte",
            "en": "Account holder"
        },
        "Modifier mon mot de passe": {
            "fr": "Modifier mon mot de passe",
            "en": "Change my password"
        },
        "Nouveau mot de passe": {
            "fr": "Nouveau mot de passe",
            "en": "New password"
        },
        "Confirmer le mot de passe": {
            "fr": "Confirmer le mot de passe",
            "en": "Confirm password"
        },
        "Sauvegarder": {
            "fr": "Sauvegarder",
            "en": "Save"
        },
        "Vous n'avez pas encore d'articles dans votre panier.": {
            "fr": "Vous n'avez pas encore d'articles dans votre panier.",
            "en": "You don't have any items in your cart yet."
        },
        "* Attention! Le prix a changé depuis que vous avez ajouté ce produit à votre panier. Vous devez le supprimer de votre panier et le réajouter pour pouvoir commander.": {
            "fr": "* Attention! Le prix a changé depuis que vous avez ajouté ce produit à votre panier. Vous devez le supprimer de votre panier et le réajouter pour pouvoir commander.",
            "en": "* Attention! The price has changed since you added this product to your cart. You must remove it from your cart and add it again to be able to order."
        }
    }
}